import React from "react";
import { BookingContext } from "../context/BookingModalContext";
import { useFormContext } from "react-hook-form";
import SharedBookingModalForm from "./SharedBookingModalForm";
import useGetAppointmentObject from "../utils/useGetAppointmentObject";
import { useFetch } from "../../../../hooks/Fetching";
import useUser from "../../../../hooks/useUser";
import SimpleAlert from "../../../display/SimpleAlert";
import { ToggleDrawerContext } from "../../../../contexts/ToggleDrawer";
import { cancelButtonVariant } from "../../../buttons/ConfirmAndCancelButtons";
import { Button, Container, Grid, Stack } from "@mui/material";
import { MUI_BUTTON_NEGATIVE } from "../../../../css/MuiClasses";
import { useTranslation } from "react-i18next";

export default function UserBooking() {
  const { currentClinic } = useUser();
  const data = React.useContext(BookingContext);
  const [isOpen, setIsOpen] = React.useContext(ToggleDrawerContext);
  const { t } = useTranslation();
  const { getObject } = useGetAppointmentObject();
  const methods = useFormContext();

  const workingDaysDto = useFetch(
    "/clinics/working_days/dto/",
    currentClinic?.id,
    "working_days_dto",
    currentClinic?.id,
    0
  );
  const workingDaysSet = workingDaysDto?.data?.workingDaySet;

  const allNonWorkingDays = workingDaysSet?.every(
    (day) => day.workingDay === false
  );

  function submittingData(e) {
    var submitObject = getObject(e);
    data.submitData(submitObject);
  }
  if (allNonWorkingDays) {
    return (
      <Container>
        <SimpleAlert
          severity={"warning"}
          message={"ClinicNotWorkingCurrently"}
          testId={"appointment.booking-form.clinic-not-working-alert"}
        />
        <Stack
          justifyContent={"end"}
          direction={"row"}
          spacing={1}
          display="flex"
          alignItems="center"
          sx={{
            flexWrap: "wrap",
            rowGap: 1,
            columnGap: 2,
            width: "100%",
            mt: 2,
          }}
        >
          <Button
            color="error"
            size="medium"
            onClick={() => setIsOpen(false)}
            className={MUI_BUTTON_NEGATIVE}
            variant={cancelButtonVariant}
            type="button"
            data-testid={"appointment.booking-form.blocked-cancel-button"}
          >
            {t("Cancel")}
          </Button>
        </Stack>
      </Container>
    );
  }

  return (
    <form onSubmit={methods.handleSubmit(submittingData)}>
      <SharedBookingModalForm />
    </form>
  );
}
